import { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { authService } from '../auth';

export const setupInterceptors = (apiClient: AxiosInstance): void => {
  // Request interceptor
  apiClient.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      // Add auth token to request headers if available
      const token = await authService.getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor
  apiClient.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error: AxiosError) => {
      const originalRequest = error.config as InternalAxiosRequestConfig & { _retry?: boolean };
      
      // Handle token refresh or redirect to login on auth errors
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        
        try {
          // Force token refresh
          const user = authService.getCurrentUser();
          if (user) {
            const newToken = await user.getIdToken(true);
            if (originalRequest.headers) {
              originalRequest.headers.Authorization = `Bearer ${newToken}`;
            }
            return apiClient(originalRequest);
          }
        } catch (refreshError) {
          // Redirect to login
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      }
      
      return Promise.reject(error);
    }
  );
};